class tableOrderList_mok{
    static getOrder(text,pageNumber,edit){
        return new Promise((resolve,reject)=>{
            setTimeout(() => {
                resolve({
                    order:[
                        {
                            id: "1",
                            orderNumber: "125478",
                            transactionNumber: "452178",
                            name: "آرش فکری",
                            phoneNumber: "09174452789",
                            city: "اصفهان، کاشان",
                            status: "در انتظار برسی",
                          },
                          {
                            id: "2",
                            orderNumber: "365214",
                            transactionNumber: "369852",
                            name: "امیر همتی‌نژاد ",
                            phoneNumber: "09334126575",
                            city: "فارس، شیراز",
                            status: "تحویل پست شده",
                          },
                          {
                            id: "3",
                            orderNumber: "963258",
                            transactionNumber: "256983",
                            name: "علی میرهادی",
                            phoneNumber: "09163214587",
                            city: "تهران، دماوند",
                            status: "در انتظار برسی",
                          },
                          {
                            id: "4",
                            orderNumber: "125478",
                            transactionNumber: "452178",
                            name: "آرش فکری",
                            phoneNumber: "09174452789",
                            city: "اصفهان، کاشان",
                            status: "تایید شده",
                          },
                          {
                            id: "5",
                            orderNumber: "365214",
                            transactionNumber: "369852",
                            name: "امیر همتی‌نژاد ",
                            phoneNumber: "09334126575",
                            city: "فارس، شیراز",
                            status: "تحویل پست شده",
                          },
                          {
                            id: "6",
                            orderNumber: "963258",
                            transactionNumber: "256983",
                            name: "علی میرهادی",
                            phoneNumber: "09163214587",
                            city: "تهران، دماوند",
                            status: "در انتظار برسی",
                          },
                          {
                            id: "7",
                            orderNumber: "125478",
                            transactionNumber: "452178",
                            name: "آرش فکری",
                            phoneNumber: "09174452789",
                            city: "اصفهان، کاشان",
                            status: "در انتظار برسی",
                          },
                          {
                            id: "8",
                            orderNumber: "365214",
                            transactionNumber: "369852",
                            name: "امیر همتی‌نژاد ",
                            phoneNumber: "09334126575",
                            city: "فارس، شیراز",
                            status: "در انتظار برسی",
                          },
                          {
                            id: "9",
                            orderNumber: "963258",
                            transactionNumber: "256983",
                            name: "علی میرهادی",
                            phoneNumber: "09163214587",
                            city: "تهران، دماوند",
                            status: "تحویل پست شده",
                          },
                          {
                            id: "10",
                            orderNumber: "963258",
                            transactionNumber: "256983",
                            name: "علی میرهادی",
                            phoneNumber: "09163214587",
                            city: "تهران، دماوند",
                            status: "تایید شده",
                          },
                    ],
                    countAll:66
                })
            }, 1000);
        })
    }
    static deleteorder(id){
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({
         status:{
          code:"1",
          massage:"با موفقیت حذف شد"
         }
          });
        }, 1000);
      });
    }
}
export {tableOrderList_mok}